import { useModelStore } from "@demo/store/model";
import { useToolCallStore } from "@demo/store/tool-calls";

/**
 * Whether the current run has shown anything yet: answer text, reasoning, or a tool call. A search run
 * often streams its tool calls before any text, so a panel that waits for text hides them while they run.
 */
export function useHasRunOutput(): boolean {
  const hasText = useModelStore((state) => state.agentText !== "" || state.reasoningText !== "");
  const hasToolCalls = useToolCallStore((state) => state.order.length > 0);
  return hasText || hasToolCalls;
}
